var cov_21h5rx2ler = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/Colgroup.tsx",
      hash = "797ce52f7ddfc37e594a3e9e1fe7ebe582b97449",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/Colgroup.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 16
        }
      },
      "1": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 16,
          column: 45
        },
        end: {
          line: 16,
          column: 55
        }
      },
      "3": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 21,
          column: 5
        }
      },
      "4": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 39
        }
      },
      "5": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 12
        }
      },
      "6": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 48
        }
      },
      "7": {
        start: {
          line: 22,
          column: 42
        },
        end: {
          line: 22,
          column: 48
        }
      },
      "8": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 63
        }
      },
      "9": {
        start: {
          line: 23,
          column: 57
        },
        end: {
          line: 23,
          column: 63
        }
      },
      "10": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 36
        }
      },
      "11": {
        start: {
          line: 29,
          column: 24
        },
        end: {
          line: 29,
          column: 34
        }
      },
      "12": {
        start: {
          line: 30,
          column: 34
        },
        end: {
          line: 30,
          column: 44
        }
      },
      "13": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 41,
          column: 5
        }
      },
      "14": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 40,
          column: 7
        }
      },
      "15": {
        start: {
          line: 35,
          column: 25
        },
        end: {
          line: 35,
          column: 50
        }
      },
      "16": {
        start: {
          line: 36,
          column: 12
        },
        end: {
          line: 36,
          column: 44
        }
      },
      "17": {
        start: {
          line: 36,
          column: 33
        },
        end: {
          line: 36,
          column: 44
        }
      },
      "18": {
        start: {
          line: 37,
          column: 12
        },
        end: {
          line: 37,
          column: 68
        }
      },
      "19": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 50,
          column: 5
        }
      },
      "20": {
        start: {
          line: 45,
          column: 23
        },
        end: {
          line: 45,
          column: 47
        }
      },
      "21": {
        start: {
          line: 46,
          column: 10
        },
        end: {
          line: 46,
          column: 42
        }
      },
      "22": {
        start: {
          line: 46,
          column: 31
        },
        end: {
          line: 46,
          column: 42
        }
      },
      "23": {
        start: {
          line: 47,
          column: 10
        },
        end: {
          line: 47,
          column: 63
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        loc: {
          start: {
            line: 8,
            column: 46
          },
          end: {
            line: 13,
            column: 3
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        loc: {
          start: {
            line: 15,
            column: 23
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 11
          },
          end: {
            line: 51,
            column: 3
          }
        },
        line: 28
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 34,
            column: 24
          },
          end: {
            line: 34,
            column: 25
          }
        },
        loc: {
          start: {
            line: 34,
            column: 34
          },
          end: {
            line: 38,
            column: 11
          }
        },
        line: 34
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 44,
            column: 21
          },
          end: {
            line: 44,
            column: 22
          }
        },
        loc: {
          start: {
            line: 44,
            column: 31
          },
          end: {
            line: 48,
            column: 9
          }
        },
        line: 44
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 21,
            column: 5
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 17,
            column: 8
          },
          end: {
            line: 17,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 8
          },
          end: {
            line: 17,
            column: 17
          }
        }, {
          start: {
            line: 17,
            column: 21
          },
          end: {
            line: 17,
            column: 30
          }
        }, {
          start: {
            line: 17,
            column: 34
          },
          end: {
            line: 17,
            column: 52
          }
        }],
        line: 17
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 48
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 22,
            column: 48
          }
        }],
        line: 22
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 22,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 8
          },
          end: {
            line: 22,
            column: 18
          }
        }, {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 40
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 63
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 63
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 63
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 23,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 8
          },
          end: {
            line: 23,
            column: 17
          }
        }, {
          start: {
            line: 23,
            column: 21
          },
          end: {
            line: 23,
            column: 55
          }
        }],
        line: 23
      },
      "6": {
        loc: {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        }],
        line: 31
      },
      "7": {
        loc: {
          start: {
            line: 31,
            column: 8
          },
          end: {
            line: 31,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 8
          },
          end: {
            line: 31,
            column: 16
          }
        }, {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 54
          }
        }],
        line: 31
      },
      "8": {
        loc: {
          start: {
            line: 36,
            column: 12
          },
          end: {
            line: 36,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 12
          },
          end: {
            line: 36,
            column: 44
          }
        }, {
          start: {
            line: 36,
            column: 12
          },
          end: {
            line: 36,
            column: 44
          }
        }],
        line: 36
      },
      "9": {
        loc: {
          start: {
            line: 36,
            column: 16
          },
          end: {
            line: 36,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 16
          },
          end: {
            line: 36,
            column: 23
          }
        }, {
          start: {
            line: 36,
            column: 27
          },
          end: {
            line: 36,
            column: 31
          }
        }],
        line: 36
      },
      "10": {
        loc: {
          start: {
            line: 46,
            column: 10
          },
          end: {
            line: 46,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 10
          },
          end: {
            line: 46,
            column: 42
          }
        }, {
          start: {
            line: 46,
            column: 10
          },
          end: {
            line: 46,
            column: 42
          }
        }],
        line: 46
      },
      "11": {
        loc: {
          start: {
            line: 46,
            column: 14
          },
          end: {
            line: 46,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 14
          },
          end: {
            line: 46,
            column: 21
          }
        }, {
          start: {
            line: 46,
            column: 25
          },
          end: {
            line: 46,
            column: 29
          }
        }],
        line: 46
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/Colgroup.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';

var Colgroup =
/*#__PURE__*/
function (_ref) {
  _inherits(Colgroup, _ref);

  var _super = _createSuper2(Colgroup);

  function Colgroup(props) {
    var _this;

    _classCallCheck(this, Colgroup);

    cov_21h5rx2ler.f[0]++;
    cov_21h5rx2ler.s[0]++;
    _this = _super.call(this, props);
    cov_21h5rx2ler.s[1]++;
    _this.state = {
      didShow: false
    };
    return _this;
  }

  _createClass(Colgroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_21h5rx2ler.f[1]++;

      var _ref2 = (cov_21h5rx2ler.s[2]++, this.props),
          colgroup = _ref2.colgroup,
          columns = _ref2.columns,
          resizable = _ref2.resizable;

      cov_21h5rx2ler.s[3]++;

      if ((cov_21h5rx2ler.b[1][0]++, !colgroup) && (cov_21h5rx2ler.b[1][1]++, resizable) && (cov_21h5rx2ler.b[1][2]++, this.state.didShow)) {
        cov_21h5rx2ler.b[0][0]++;
        cov_21h5rx2ler.s[4]++;
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          didShow: false
        });
        cov_21h5rx2ler.s[5]++;
        return;
      } else {
        cov_21h5rx2ler.b[0][1]++;
      }

      cov_21h5rx2ler.s[6]++;

      if ((cov_21h5rx2ler.b[3][0]++, !resizable) || (cov_21h5rx2ler.b[3][1]++, this.state.didShow)) {
        cov_21h5rx2ler.b[2][0]++;
        cov_21h5rx2ler.s[7]++;
        return;
      } else {
        cov_21h5rx2ler.b[2][1]++;
      }

      cov_21h5rx2ler.s[8]++;

      if ((cov_21h5rx2ler.b[5][0]++, !colgroup) || (cov_21h5rx2ler.b[5][1]++, colgroup.length !== columns.length)) {
        cov_21h5rx2ler.b[4][0]++;
        cov_21h5rx2ler.s[9]++;
        return;
      } else {
        cov_21h5rx2ler.b[4][1]++;
      } // eslint-disable-next-line react/no-did-update-set-state


      cov_21h5rx2ler.s[10]++;
      this.setState({
        didShow: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      cov_21h5rx2ler.f[2]++;

      var _ref3 = (cov_21h5rx2ler.s[11]++, this.state),
          didShow = _ref3.didShow;

      var _ref4 = (cov_21h5rx2ler.s[12]++, this.props),
          columns = _ref4.columns,
          colgroup = _ref4.colgroup;

      cov_21h5rx2ler.s[13]++;

      if ((cov_21h5rx2ler.b[7][0]++, colgroup) && (cov_21h5rx2ler.b[7][1]++, colgroup.length === columns.length)) {
        cov_21h5rx2ler.b[6][0]++;
        cov_21h5rx2ler.s[14]++;
        return (
          /*#__PURE__*/
          React.createElement("colgroup", {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 33,
              columnNumber: 9
            }
          }, colgroup.map(function (c, i) {
            cov_21h5rx2ler.f[3]++;
            var last = (cov_21h5rx2ler.s[15]++, colgroup.length - 1 === i);
            cov_21h5rx2ler.s[16]++;

            if ((cov_21h5rx2ler.b[9][0]++, didShow) && (cov_21h5rx2ler.b[9][1]++, last)) {
              cov_21h5rx2ler.b[8][0]++;
              cov_21h5rx2ler.s[17]++;
              return null;
            } else {
              cov_21h5rx2ler.b[8][1]++;
            }

            cov_21h5rx2ler.s[18]++;
            return (
              /*#__PURE__*/
              React.createElement("col", {
                key: columns[i].key,
                style: {
                  width: c
                },
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 37,
                  columnNumber: 20
                }
              })
            );
          }))
        );
      } else {
        cov_21h5rx2ler.b[6][1]++;
      }

      cov_21h5rx2ler.s[19]++;
      return (
        /*#__PURE__*/
        React.createElement("colgroup", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 43,
            columnNumber: 7
          }
        }, columns.map(function (c, i) {
          cov_21h5rx2ler.f[4]++;
          var last = (cov_21h5rx2ler.s[20]++, columns.length - 1 === i);
          cov_21h5rx2ler.s[21]++;

          if ((cov_21h5rx2ler.b[11][0]++, didShow) && (cov_21h5rx2ler.b[11][1]++, last)) {
            cov_21h5rx2ler.b[10][0]++;
            cov_21h5rx2ler.s[22]++;
            return null;
          } else {
            cov_21h5rx2ler.b[10][1]++;
          }

          cov_21h5rx2ler.s[23]++;
          return (
            /*#__PURE__*/
            React.createElement("col", {
              key: c.key,
              style: {
                width: c.width
              },
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 47,
                columnNumber: 18
              }
            })
          );
        }))
      );
    }
  }]);

  return Colgroup;
}((React.Component));

export default Colgroup;